import { render } from "./BrandZurnal24.vue?vue&type=template&id=7b6121a0"
import script from "./BrandZurnal24.vue?vue&type=script&lang=ts"
export * from "./BrandZurnal24.vue?vue&type=script&lang=ts"

import "./BrandZurnal24.vue?vue&type=style&index=0&id=7b6121a0&lang=scss"
script.render = render

export default script